var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.143,
    height: 36,
    viewBox: "0 0 32.143 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "secure",
    d: "M44,5.039a1.177,1.177,0,0,0-.85-.971L28.683.044a1.176,1.176,0,0,0-.631,0L13.583,4.067a1.177,1.177,0,0,0-.85.971c-.084.6-2,14.862,2.912,21.955a23.1,23.1,0,0,0,12.446,8.974,1.18,1.18,0,0,0,.552,0A23.1,23.1,0,0,0,41.09,26.994C46,19.9,44.086,5.642,44,5.039Zm-6.3,8.324-9.869,9.869a1.176,1.176,0,0,1-1.664,0l-6.1-6.1a1.176,1.176,0,0,1,0-1.664l1.212-1.212a1.176,1.176,0,0,1,1.664,0L27,18.314l7.826-7.826a1.176,1.176,0,0,1,1.664,0L37.7,11.7A1.177,1.177,0,0,1,37.7,13.363Z",
    transform: "translate(-12.296 -0.001)",
    fill: "#67E1AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIco);
export default __webpack_public_path__ + "static/media/secureIco.a57ccc34589112f0d8f58e0b281ef9a6.svg";
export { ForwardRef as ReactComponent };